import React from 'react';


export function MainLoadingComponent({
    text = 'Aguarda...',
    TagName = 'div',
    className = '',
    linesCount = 4,
    children
}) {
    
    return (
        <TagName className={`main-loading ${className}`}>
            
            {(new Array(linesCount)).fill({}).map(({
                animationDuration = `${Math.random() * (2 - 1 + 1) + 1}s`
            }, index) => (
                <div className="line" key={index} style={{
                    animationDuration
                }}>
                    <div className="outer-dot loading-dot" style={{
                        animationDuration
                    }}>
                        <div className="inner-dot loading-dot"></div>
                    </div>
                </div>
            ))}

            {!text ? null :(
                <div className="bottom-content">
                    {text}
                </div>
            )}

            {children}
        </TagName>
    );
};